import { useEffect, useState } from 'react';

export function useOrganiserLinks(squadId) {
  const [showOrganiserModal, setShowOrganiserModal] = useState(false);
  const [organiserLinks, setOrganiserLinks] = useState(null);

  // Check for organiser links in sessionStorage (from squad creation)
  useEffect(() => {
    const storedLinks = sessionStorage.getItem(`organiser_links_${squadId}`);
    if (storedLinks) {
      try {
        const links = JSON.parse(storedLinks);
        setOrganiserLinks(links);
        setShowOrganiserModal(true);
        // Remove from sessionStorage so it doesn't show again on refresh
        sessionStorage.removeItem(`organiser_links_${squadId}`);
      } catch (error) {
        console.error('Error parsing organiser links:', error);
      }
    }
  }, [squadId]);

  return {
    showOrganiserModal,
    setShowOrganiserModal,
    organiserLinks,
    setOrganiserLinks,
  };
}
